import React from 'react';
import { useLabels } from 'wsm-common-data';
import PropTypes from 'prop-types';
import { setClassNames } from 'ddc-classnames-js';

const VehicleImageCount = ({ mediaCount, imageIndex, onClick, className }) => {
	const labels = useLabels();
	const galleryCountLabel = labels
		.get('GALLERY_IMAGE_COUNT')
		.replace('{imageIndex}', imageIndex)
		.replace('{mediaCount}', mediaCount);
	const contentBtn = (
		<span
			className={setClassNames([
				'ddc-font-size-xsmall',
				'font-weight-bold'
			])}
		>
			<span aria-hidden="true">
				{imageIndex} / {mediaCount}
			</span>
			<span className="sr-only">{galleryCountLabel}</span>
		</span>
	);
	return (
		<button
			type="button"
			onClick={onClick}
			data-testid="gallery-button"
			className={className}
		>
			{contentBtn}
		</button>
	);
};

VehicleImageCount.propTypes = {
	className: PropTypes.string,
	mediaCount: PropTypes.number.isRequired,
	imageIndex: PropTypes.number.isRequired,
	onClick: PropTypes.func
};

export default VehicleImageCount;
